import { Interval, IntervalMapping, MoneyFormatter, PercentageFormatter } from '@summit/models';

import { EboObjectTimePeriod } from '../../base-classes/ebo-object-time-period';
import { PayrollReportingCategory } from '../../payroll/payroll-reporting-category.enum';
import { State } from '../../places/state/state';
import { Company } from './company';

export class CompanyStatePayrollRate extends EboObjectTimePeriod {
  companyID: string;
  company: Company;
  stateID: string;
  state: State;
  category: PayrollReportingCategory;
  isSalaryOnly: boolean;
  fixed: number;
  fixedInterval: Interval;
  rate: number;
  cap: number;
  threshold: number;
  additionalRate: number;
  comment: string;

  constructor(jsonData?: Partial<CompanyStatePayrollRate>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.company) {
        this.company = new Company(jsonData.company);
      }
      if (jsonData.state) {
        this.state = new State(jsonData.state);
      }
    }
    if (!this.isSalaryOnly) {
      this.isSalaryOnly = false;
    }
    this.fixedInterval ??= Interval.Weekly;
    this.category ??= PayrollReportingCategory.Unknown;
  }

  get summary(): string {
    if (this.fixed) {
      return `${MoneyFormatter(this.fixed)} ${IntervalMapping[this.fixedInterval]}`;
    }
    const response = Array<string>();
    if (this.rate) {
      response.push(`${PercentageFormatter(this.rate / 100, 3)}`);
    }
    if (this.cap) {
      response.push(`up to ${MoneyFormatter(this.cap)}`);
    }
    if (this.threshold || this.additionalRate) {
      response.push(
        `and up ${MoneyFormatter(this.threshold)} add ${PercentageFormatter(this.additionalRate / 100, 3)}`
      );
    }
    return response.join(' ');
  }

  toShortString(): string {
    return `${this.company ? this.company.toShortString() : 'Unknown'}-${
      this.state ? this.state.toShortString() : 'Unknown'
    }`;
  }

  toTimeLineView(): string {
    return `${this.startTime.format('MM/DD/YY')} - ${this.endTime ? this.endTime.format('MM/DD/YY') : 'Current'}: ${
      this.company ? this.company.toShortString() : 'Unknown'
    }`;
  }
}
